import type { KnowledgeBaseFile } from "@/app/store/api/knowledgeBaseApi"
import type { DeckType } from "../deck-type-chips"
import { Monitor, FileText, TrendingUp, Search } from "lucide-react"

export type PromptFile = File | KnowledgeBaseFile

export const DECK_TYPE_CONFIG: Record<
    string,
    { label: string; icon: React.ElementType }
> = {
    "Presentation": { label: "Presentation", icon: Monitor },
    "documents": { label: "Documents", icon: FileText },
    "fundraising-pitch-deck": { label: "Fundraising Pitch Deck", icon: TrendingUp },
    "business-pitch-deck": { label: "Business Pitch Deck", icon: TrendingUp },
    "deep-research": { label: "Deep Research", icon: Search },
}

export const MIN_PROMPT_LENGTH = 10
export const MAX_FILES = 3

export interface SelectedTemplate {
    id: string
    name: string
    thumbnail?: string
}

export interface PitchDeckDetails {
    companyName: string
    website: string
    industry: string
    stage: string
    slideCount: string
}

export interface PromptBarProps {
    selectedDeckType: DeckType
    selectedDocumentSubtype: string | null
    onDeepResearchClick: () => void
    onFastSearchClick: () => void
    onSubmit: () => void
    isLoading: boolean
    files?: PromptFile[]
    onFilesChange?: (files: PromptFile[]) => void
    logoFile?: File | null
    onLogoChange?: (file: File | null) => void
    prompt?: string
    onPromptChange?: (value: string) => void
    selectedTemplate?: SelectedTemplate
    onRemoveTemplate?: () => void
    pitchDeckDetails?: PitchDeckDetails
    onPitchDeckDataChange?: (field: string, value: string) => void
    onSwitchToFundraising?: () => void
}
